// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-pixellot-loading{align-items:center;background:hsla(0,0%,96%,.7);display:flex;height:100%;justify-content:center;left:0;opacity:.75;position:absolute;top:0;width:100%;z-index:1000}.vue-pixellot-loading.fullscreen{background-color:#f5f5f5;bottom:0;left:0;position:fixed;right:0;top:0;z-index:999}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
